import axios from 'axios'

import { VendorLogo } from 'common/server/server_types'

export interface Vendor {
  description?: string
  domain: string
  id: string
  logo?: VendorLogo
  name: string
  default_quote_valid_for_days: number
  billing: VendorBilling
}

interface VendorBilling {
  stripe_customer_id: string
  // Key value is of type VendorUserTiers
  seats_available: { [key: string]: number }
}

export interface UpdateVendorRequest {
  description?: string
  logo_signed_id?: string
  default_quote_valid_for_days?: number
}

export function update_vendor(payload: UpdateVendorRequest) {
  return axios.patch<Vendor>('/vendor/vendor', { vendor: payload })
}
